module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hotsite-dcom', [_c('div', {
    staticClass: "conteudo"
  }, [_c('bloco', {
    staticClass: "-nomargin -softpadding -fullheight"
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar -upper"
  }, [_vm._v("Legislação")])], 1), (_vm.legislacoes) ? _c('div', {
    staticClass: "texto",
    attrs: {
      "slot": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.legislacoes)
    },
    slot: "content"
  }) : _c('loading', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }), _c('footer', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('back-and-share')], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26461041","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/dcom/Legislacoes.vue
// module id = 470
// module chunks = 0